import React from 'react';
import styled from 'styled-components';

import CollapseSrc from './collapse.png';
import ExpandSrc from './expand.png';
import Typography from 'kingpin/atoms/Typography';
import Row from '../Common/Row';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  box-shadow: var(--shadow-sm);
`;
const getHeight = ({ isDashboardCard }: { isDashboardCard: boolean }) => {
  if (isDashboardCard) {
    return 24;
  } else {
    return 32;
  }
};

const Left = styled.button<{
  isSelected: boolean;
  isNarrowCard?: boolean;
  isDashboardCard?: boolean;
}>`
  height: ${(props) =>
    getHeight({ isDashboardCard: !!props.isDashboardCard })}px;
  background-color: ${(props) =>
    props.disabled ? 'var(--color-grey-8)' : 'var(--color-bg-primary)'};

  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border: 1px solid;
  border-color: ${(props) =>
    props.isSelected ? 'var(--color-info-v2)' : 'var(--color-border-primary)'};
  border-right: ${(props) =>
    props.isSelected
      ? `1px solid var(--color-info-v2)`
      : `1px solid transparent`};

  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;
const Right = styled.button<{
  isSelected: boolean;
  isDashboardCard?: boolean;
}>`
  height: ${(props) =>
    getHeight({ isDashboardCard: !!props.isDashboardCard })}px;
  background-color: ${(props) =>
    props.disabled ? 'var(--color-grey-8)' : 'var(--color-bg-primary)'};

  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border: 1px solid;
  border-color: ${(props) =>
    props.isSelected ? 'var(--color-info-v2)' : 'var(--color-border-primary)'};

  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

const Buttons = ({
  leftText,
  rightText,
  isLeftSelected,
  isRightSelected,
  onLeftClicked,
  onRightClicked,
  isDisabled,
  isNarrowCard,
  isDashboardCard,
  isOpen,
}: {
  leftText: string;
  rightText: string;
  isLeftSelected: boolean;
  isRightSelected: boolean;
  onLeftClicked: () => void;
  onRightClicked: () => void;
  isDisabled?: boolean;
  isNarrowCard?: boolean;
  isDashboardCard?: boolean;
  isOpen: boolean;
}) => (
  <Wrapper className={isOpen ? '' : 'opaque-unless-mouse-over'}>
    <Left
      isSelected={isLeftSelected}
      onClick={onLeftClicked}
      data-testid="date-left"
      disabled={isDisabled}
      isNarrowCard={isNarrowCard}
      isDashboardCard={isDashboardCard}
    >
      <Row
        centerAlign
        spaceBetween
        style={{ height: '100%', padding: '0px 8px', gap: '8px' }}
      >
        <Typography.Body
          type="Placeholder"
          color={'var(--color-grey-1)'}
          isEllipsis
        >
          {leftText}
        </Typography.Body>
        <img src={isLeftSelected ? CollapseSrc : ExpandSrc} alt="tick" />
      </Row>
    </Left>
    <Right
      isSelected={isRightSelected}
      onClick={onRightClicked}
      data-testid="date-right"
      disabled={isDisabled}
      isDashboardCard={isDashboardCard}
    >
      <Row
        centerAlign
        spaceBetween
        style={{ height: '100%', padding: '0px 8px', gap: '8px' }}
      >
        <Typography.Body
          type="Placeholder"
          color={'var(--color-grey-1)'}
          isEllipsis
        >
          {rightText}
        </Typography.Body>
        <img src={isRightSelected ? CollapseSrc : ExpandSrc} alt="tick" />
      </Row>
    </Right>
  </Wrapper>
);

export default Buttons;
